export default {
  breadcrumb: 'Settings / Site /',
  title: 'Translations',
  siteLanguagesButton: 'Site Languages',
  activeTranslationsModal: {
    title: 'Translations available',
    localLanguageToggle: {
      label: 'Show in local language',
    },
  },
  filterBar: {
    searchInput: {
      placeholder: 'Search for a translation key',
    },
  },
  translations: {
    table: {
      headers: {
        title: 'Title',
        default: 'Default',
        schemeServe: 'SchemeServe',
        custom: 'Custom',
      },
    },
  },
};
